<template>
  <div style="padding-left: 1.75rem">
    <div class="col2_head">
      <router-link :to="'/'" class="breadcrumb_home">Acasă /</router-link>
      {{ $route.name }}
      <div class="subHeadTitle">
        {{ $route.name }}
      </div>
    </div>
    <template>
      <template v-if="PERMISIONS.list">
        <table-parent
          :reloadCount="reloadTable"
          :tableHead="tableHead"
          :prepareFn="prepareData"
          :apiModule="tableModule"
          apiModuleName="ASSIGNMENT_DOCUMENTS"
          :tableMinimizeHead="true"
          :tableSpread="true"
          @Btn7="viewProducts"
          @Btn14="viewPdf"
          @Btn2="editItem"
          @Btn3="deleteItem"
          @Btn4="addDocuments"
          @Btn5="closeAssignmentDocument"
          @Btn6="openAddress"
          @Btn42="requestApprove"
          @totalRecords="(x) => (totalRecords = x)"
        />
      </template>
      <template v-else>
        <h3 style="display: flex; flex-direction: column; align-items: center">
          <span style="font-size: 4rem">
            <i class="fas fa-exclamation-triangle"></i>
          </span>
          Acces interzis
        </h3>
      </template>
    </template>
  </div>
</template>

<script>
import PermisionsMixin from "../mixins/assignmentDocumentsPermMixin.js";
import updateRoleStatus from "../mixins/updateUserRoleStatus.js";
import { ASSIGNMENT_DOCUMENTS } from "../api.js";
import DialogModal from "@/components/DialogModal";
import TableParent from "@/components/TableParent";
import AssignmentProducts from "@/components/assignment-products/AssignmentProducts";
import { mapMutations, mapGetters } from "vuex";
import { AssignmentDocumentType } from "../common/types/command.type.js";

export default {
  name: "Achizitii",
  $Title() {
    return `ConectX - ${this.$route.name}`;
  },
  mixins: [PermisionsMixin, updateRoleStatus],
  components: {
    TableParent,
  },
  data() {
    return {
      centralization: null,
      tableHead: [
        {
          title: "Număr achiziție",
          sort: true,
          queryKey: "assignmentNumber",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Data achiziție",
          queryKey: "assignmentDate",
          bottomHead: {
            quikFiltre: "date",
          },
        },
        {
          title: "Furnizor",
          queryKey: "institutionProvider",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Valoare totală fără TVA",
          queryKey: "totalValueWithoutTva",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Cotă TVA",
          queryKey: "tvaValue",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Valoare totală cu TVA",
          queryKey: "totalValueWithTva",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          spacer: true,
          minimize: 1,
          fixed: {
            right: true,
          },
          queryKey: "status",
          bottomHead: {
            quikFiltre: "assignmentDocumentStatus",
          },
        },
      ],
      tableModule: (x, y) => ASSIGNMENT_DOCUMENTS.get(x, y),
      totalRecords: 0,
      reloadTable: 0,
    };
  },
  methods: {
    ...mapMutations(["setReferenceIdForPreview"]),

    reload() {
      this.reloadTable++;
    },
    openAddress(item) {
      window.open(item.conectxAddressUrl, "_blank");
    },
    prepareData(row) {
      const preparation = [
        row.assignmentNumber || "",
        this.toDate(row.assignmentDate) || "",
        row.institutionProvider?.name || "",
        this.prepareLocaleNumber(row.totalValueWithoutTva) || "",
        this.prepareLocaleNumber(row.tvaValue) || "",
        this.prepareLocaleNumber(row.totalValueWithTva) || "",
        {
          draft: {
            border: "left",
            icon: "far fa-clock",
            css: "padding: 0.5rem;color: #f2da07;font-size: 2rem;",
            tooltip: "Draft",
          },
          generated: {
            border: "left",
            icon: "fas fa-pencil",
            css: "padding: 0.5rem;color: #569a36;font-size: 2rem;",
            tooltip: "Generat",
          },
          waiting_approve: {
            border: "left",
            icon: "fas fa-clock",
            css: "padding: 0.5rem;color: #f2da07;font-size: 2rem;",
            tooltip: "Așteptare aprobare",
          },
          signing_failed: {
            border: "left",
            icon: "fas fa-exclamation-triangle",
            css: "padding: 0.5rem;color: #ec4a4a;font-size: 2rem;",
            tooltip: "Semnare eșuată",
          },
          rejected: {
            border: "left",
            icon: "fas fa-times-circle",
            css: "padding: 0.5rem;color: #ec4a4a;font-size: 2rem;",
            tooltip: "Respins",
          },
          approved: {
            border: "left",
            icon: "fas fa-clipboard-check",
            css: "padding: 0.5rem;color: #569a36;font-size: 2rem;",
            tooltip: "Aprobat",
          },
          closed: {
            border: "left",
            icon: "fas fa-badge-check",
            css: "padding: 0.5rem;color: green;font-size: 2rem;",
            tooltip: "Finalizat",
          },
        }[row.status] || "-",
      ];

      const prepareBtn = [];
      prepareBtn.push([7, "Produse"]);

      if (row.status != "draft") {
        prepareBtn.push(14);
      }
      if (
        row.status != "approved" &&
        row.status != "waiting_approve" &&
        row.status != "signing_failed" &&
        row.assignmentType != AssignmentDocumentType.ComandaFermaTip3 &&
        row.status != "closed"
      ) {
        prepareBtn.push(2);
      }

      if (
        row.status != "approved" &&
        row.status != "waiting_approve" &&
        row.status != "closed"
      ) {
        prepareBtn.push(3);
      }

      if (prepareBtn.length) {
        preparation.push([prepareBtn]);
      }

      return preparation;
    },

    viewPdf(data) {
      this.setReferenceIdForPreview({
        data: {
          id: data.id,
        },
        origin: "ASSIGNMENT_PDF",
      });
    },

    viewProducts(item) {
      this.$modal.show(
        DialogModal,
        {
          target: "AssignmentProducts",
          title: "Produse",
          inputs: [
            {
              id: "assignmentProducts",
              type: "component",
              component: AssignmentProducts,
              componentProps: { assignmentDocument: item },
            },
          ],
          closeBtnText: "Anulează",

          button: {
            type: 2,
            value: "Generează",
            disabled:
              item.status == "waiting_approve" ||
              item.status == "signing_failed" ||
              item.status == "approved" ||
              item.status == "closed",
            handler: (sendData) => {
              const data = sendData.assignmentProducts;

              const error = (msg) => {
                this.$toastr.e(msg || "Generarea a eșuat.");
                this.reload();
                this.setLoad();
              };

              this.setSafeLoad(12000);
              ASSIGNMENT_DOCUMENTS.generate(data.id)
                .then((res) => {
                  if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                    this.$toastr.s("Generarea comenzii ferme s-a efectuat.");
                    this.reload();
                    this.setLoad();
                  } else {
                    error(res.response);
                  }
                })
                .catch(error);
            },
          },

          customClass: "custom-size",
        },
        {
          name: "AssignmentProducts",
          adaptive: true,
          width: "100%",
          height: "100%",
        }
      );
    },
  },

  computed: {
    ...mapGetters(["getProcedureTypes"]),
  },
  created() {
    if (!this.PERMISIONS.list) {
      return;
    }

    const canViewButtonsColumn = ["edit", "delete"];

    this.updateRoleStatus();
    if (this.checkParamsInObj(this.PERMISIONS, canViewButtonsColumn)) {
      this.tableHead.push({
        spacer: true,
        minimize: 1,
        fixed: {
          right: true,
        },
        bottomHead: {
          quikFiltre: "clear",
        },
      });
    }
  },
};
</script>
<style>
.assignmentDocument-docs {
  max-width: 1200px !important;
  max-height: 1200px !important;
}

.custom-size {
  max-width: 1200px !important;
  max-height: 100% !important;
}
</style>
